import './Formulaire Je Candidate/polyfills';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './index.css';
import App from './App';
import AdminCatalog from './Formulaire Je Candidate/AdminCatalog';
import AdminTemplate from './AdminTemplate';
import AdminDossiers from './AdminDossiers';
import AdminExchanges from './exchanges/AdminExchanges';
import AdminPortal from './admin/AdminPortal';
import reportWebVitals from './reportWebVitals';
import StudentBrand from './student/StudentBrand';
import CandidatureReview from './student/CandidatureReview';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <Routes>
        <Route path="/admin/catalog" element={<AdminCatalog />} />
        <Route path="/admin/template" element={<AdminTemplate />} />
        <Route path="/admin/dossiers" element={<AdminDossiers />} />
        <Route path="/admin/echanges" element={<AdminExchanges />} />
        <Route path="/admin" element={<AdminPortal view="home" />} />
        <Route path="/admin/mails" element={<AdminPortal view="mail" />} />
        <Route path="/admin/salesforce" element={<AdminPortal view="salesforce" />} />
        <Route path="/admin/acces" element={<AdminPortal view="access" />} />
        <Route path="/avis-responsable" element={<StudentBrand><CandidatureReview /></StudentBrand>} />
        <Route path="/*" element={<StudentBrand><App /></StudentBrand>} />
      </Routes>
    </Router>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
